import { useSyncExternalStore } from "react";
import { sessionKey, subscribeToSession } from "./session";

/**
 * Qui est connecté, right now : l'empreinte du jeton (vide sans session).
 *
 * ⚠️ DANS UN FICHIER À PART de `useSession`, que plusieurs tests remplacent en bloc :
 * y ajouter un export aurait fait échouer chacun d'eux sur un export manquant.
 *
 * Même mécanique que `useSession` (`useSyncExternalStore`, l'onglet voisin compris),
 * mais la valeur est une chaîne : un changement de COMPTE la change, alors que le
 * booléen « connecté » restait vrai. Voir `fingerprint` dans `session.ts`.
 */
export function useSessionKey(): string {
  return useSyncExternalStore(subscribeToSession, sessionKey, () => "");
}
